import { mensagemCampoObrigatorio } from '@core/util/mensagemUtil';
import * as yup from 'yup';

const ContratoRescisaoSchema = yup.object().shape({
  data: yup
    .date()
    .nullable()
    .required(mensagemCampoObrigatorio('a data da rescisão')),
  motivo: yup
    .string()
    .nullable()
    .required(mensagemCampoObrigatorio('o motivo')),
});

export default ContratoRescisaoSchema;
